import { createSelector } from 'reselect';
import differenceBy from 'lodash/differenceBy';
import { whatIfOptionsOrDefaultSelector, whatIfInnerSelector } from '../../WhatIfsSelector';

export const distributionsSelector = (state, props) =>
  (whatIfOptionsOrDefaultSelector(state, props).DistributionsIncluded || [])
    .concat(whatIfOptionsOrDefaultSelector(state, props).DistributionsExcluded || []);

export const distributionsIsCustomSelector = (state, props) =>
  whatIfInnerSelector(state, props).DistributionsIsCustom;

export const includedDistributionAccountsSelector = createSelector(
  whatIfInnerSelector,
  distributionsSelector,
  distributionsIsCustomSelector,
  whatIfOptionsOrDefaultSelector,
  (whatIfInner, distributions, distributionsIsCustom, options) => {
    if (distributionsIsCustom) {
      return whatIfInner.IncludedDistributionAccounts.reduce((accumulator, accountId) => {
        const account = distributions.find(({ AccountId }) => AccountId === accountId);
        if (account) {
          return accumulator.concat([account]);
        }
        return accumulator;
      }, []);
    }
    return options.DistributionsIncluded || [];
  },
);

export const excludedDistributionAccountsSelector = createSelector(
  includedDistributionAccountsSelector,
  distributionsSelector,
  (includedDistributionAccounts, distributions) =>
    differenceBy(distributions, includedDistributionAccounts, ({ AccountId }) => AccountId),
);
